import storeLocal from 'store/dist/store.modern'
import TestModel from '@/store/models/tests/model'
import QuestionModel from '@/store/models/questions/model'
import {find, filter} from 'lodash'

export const restoreCache = () => {
    return
    if (storeLocal.get('current-test')) {
        TestModel.insert({data: storeLocal.get('current-test')})
    }
    if (storeLocal.get('current-test-question-list')) {
        QuestionModel.insert({data: storeLocal.get('current-test-question-list')})
    }
    if (storeLocal.get('current-test-question-items')) {
        QuestionModel.insert({data: storeLocal.get('current-test-question-items')})
    }
}

export const resetCache = () => {
    return
    storeLocal.clearAll()
}

export const createTest = (test) => {
    return
    storeLocal.set('current-test', test)
}

export const saveQuestionList = (questionList) => {
    return
    storeLocal.set('current-test-question-list', questionList)
}

export const saveQuestionItem = (questionItem) => {
    return
    let questionItems = storeLocal.get('current-test-question-items')
    if (!questionItems) {
        questionItems = []
    }
    questionItems = filter(questionItems, item => item.id !== questionItem.id)
    questionItems.push(questionItem)
    storeLocal.set('current-test-question-items', questionItems)
}

export const saveAnswer = (questionId, answer) => {
    return
    let questionItems = storeLocal.get('current-test-question-items')
    if (!questionItems) {
        questionItems = []
    }
    let questionItem = find(questionItems, item => item.id === questionId)
    if (questionItem) {
        questionItem.answer = answer
    }

    saveQuestionItem(questionItem)
}